import { useCallback } from 'react';
import { useImagingContext } from 'domains/viewer/ViewportDre/modules/imaging/ImagingContext';
import type { ToolInteractionUpdateViewportSliceResponse } from 'generated/graphql';
import { useViewType, useViewportId } from '../../../modules/state';

export function useUpdateViewportSliceResponse(): (
  response: Readonly<ToolInteractionUpdateViewportSliceResponse>
) => void {
  const viewType = useViewType();
  const { imagingProvider } = useImagingContext();
  const activeViewportId = useViewportId();
  const stackSmid = imagingProvider?.stack.smid;

  const updateViewportSlice = useCallback(
    ({ slice, viewportId }: Readonly<ToolInteractionUpdateViewportSliceResponse>) => {
      if (stackSmid != null && imagingProvider) {
        imagingProvider.setActiveSlice(viewType, viewportId ?? activeViewportId, slice);
      }
    },
    [activeViewportId, imagingProvider, stackSmid, viewType]
  );

  return updateViewportSlice;
}
